import { CompatibleProductId } from '@atlassian/mpac-types';
export const buildProductCloudAppUrls = _ref => {
  let {
    product,
    baseUrl,
    getStartedExtension,
    configExtension
  } = _ref;
  if (product === CompatibleProductId.Confluence) {
    return {
      getStartedUrl: getStartedExtension && "".concat(baseUrl, "/admin/forge?id=").concat(encodeURIComponent(getStartedExtension.id)),
      configureUrl: configExtension && "".concat(baseUrl, "/admin/forge?id=").concat(encodeURIComponent(configExtension.id))
    };
  }
  if (product === CompatibleProductId.Jira) {
    return {
      getStartedUrl: getStartedExtension && buildJiraExtensionSettingsPath(baseUrl, getStartedExtension, 'get-started'),
      configureUrl: configExtension && buildJiraExtensionSettingsPath(baseUrl, configExtension, 'configure')
    };
  }
  if (product === CompatibleProductId.COMPASS) {
    const configureUrl = configExtension && buildCompassExtensionSettingsPath(baseUrl, configExtension.id);
    return {
      configureUrl
    };
  }
  return {};
};
const buildJiraExtensionSettingsPath = (baseUrl, extension, settingsType) => {
  // exntension.id example: ari:cloud:ecosystem::extension/appId/envId/static/hello-world-admin-page
  const [, appId, envId] = extension.id.split('/');
  return "".concat(baseUrl, "/jira/settings/apps/").concat(settingsType, "/").concat(appId, "/").concat(envId);
};
const buildCompassExtensionSettingsPath = (baseUrl, extension) => {
  /* The redirection link for configure in compass uses base64 conversion of the extension.id which is done with
    btoa() function.
    Read: https://developer.mozilla.org/en-US/docs/Web/API/btoa
   */
  const encodedAppAri = encodeURIComponent("b:".concat(btoa(extension)));
  return "".concat(baseUrl, "/compass/apps/").concat(encodedAppAri);
};